// extracted by mini-css-extract-plugin
module.exports = {"modal-backdrop":"Modal_modal-backdrop__3a_s4","modal-overlay":"Modal_modal-overlay__WK4yG","slide-down":"Modal_slide-down__W3MdX"};